module.exports = __webpack_public_path__ + "static/media/clock.c54889ec.svg";